import { createStyles, type StylesClasses } from '@utils/styles'

const styles = createStyles({
  cardWrapper: {
    padding: '1.5rem 2rem',
    transition: 'all 0.2s ease-in-out',

    borderRadius: '8px',
  },
  cardSelected: {
    outline: '2px solid',
    outlineColor: 'highlight.dark',
    scale: '1.02',
  },
  button: {
    maxWidth: 'fit-content',
    backgroundColor: 'background.paperDark',
    color: 'text.primaryDark',
    marginTop: '0.25rem',
  },
  buttonIcon: {
    width: '24px',
    height: '24px',
  },
  image: {
    width: '736px',
    display: {
      xs: 'none',
      sm: 'block',
    },
  },
})

export default styles
export type StylesClassNames = StylesClasses<typeof styles>
